<ion-row class="order-item">
	<ion-col class="img_section" size="3">
		<div class="img_wrap">
			@if (articleGroup.article?.assets?.medium) {
				<ion-img [src]="articleGroup.article.assets.medium" class="article-img"></ion-img>
			}
			@if (!articleGroup.article?.assets?.medium) {
				<ion-img class="default-img" src="../../../assets/topgolf/header_logo.svg"></ion-img>
			}
		</div>
		<div class="discount-badges">
			@for (discount of discountBadges; track $index) {
				<app-double-monday-component [label]="discount.consumerDisplayname"></app-double-monday-component>
			}
		</div>
	</ion-col>
	<ion-col class="content-info" size="9">
		<ion-row class="name-row">
			<ion-col class="center-vertical" size="8" sizeXl="7">
				<h2 class="order-article-name">
					{{ articleGroup.article.name | langObservable | async }}
				</h2>
			</ion-col>
			<ion-col class="items-block" size="4" sizeXl="3">
				<!-- <div class="circle-quantity">
                <p>
                  {{ articleGroup.quantity }}
                </p>
              </div> -->
				@if (!articleGroup?.redeemWithPiggyPoints) {
					<h2 class="article-price">
						{{ numberToCurrency(articleGroupPrice, order.currency) }}
					</h2>
				}
				@if (articleGroup?.redeemWithPiggyPoints) {
					<h2 class="article-price">-{{ articleGroup?.redeemPointsWithPiggy * articleGroup.quantity }} PUNKTE</h2>
				}
			</ion-col>
		</ion-row>
		<ion-row class="extras-row">
			@if (groupedOptions && groupedOptions.length > 0) {
				<div class="extras-list">
					@for (groupedOption of groupedOptions; track trackByGroupId($index, groupedOption)) {
						@for (group of groupedOption.listOfOptionArticles; track trackByOptionId($index, group)) {
							@if (!hiddenInCart(group.article)) {
								<div class="extra-item">
									<span class="extra-name">{{ group.article.name | langObservable | async }}</span>
									@if (priceOfOption(group); as optionPrice) {
										<span class="extra-price">
											@if (optionPrice > 0) {
												{{ numberToCurrency(optionPrice, order.currency) }}
											}
										</span>
									}
								</div>
							}
						}
					}
				</div>
			}
		</ion-row>
		@if (articleGroup.note && articleGroup.note.length > 0) {
			<div class="note">
				<span>{{ 'order_list.note_prefix' | translate }} {{ articleGroup.note }}</span>
			</div>
		}
		@if (!hideAllActions) {
			<ion-row class="paddig-top">
				<ion-col class="center-vertical" size="6">
					<div class="quantity-selector">
						<ion-icon
							(click)="remove(); $event.stopPropagation()"
							class="quantity-btn-left"
							src="../../../assets/icon/minus.svg"
						></ion-icon>
						<p class="quantity">{{ articleGroup.quantity }}</p>
						<ion-icon (click)="add()" class="quantity-btn-right" src="../../../assets/icon/plus.svg"></ion-icon>
					</div>
				</ion-col>
				<ion-col size="6">
					<div class="flex center-vertical flex-end">
						<div class="icons_block">
							<div class="edit_section">
								<ion-icon
									(click)="edit()"
									[class.ion-hide]="!isEditable() || articleGroup.article.groups.length <= 0"
									class="edit-btn"
									src="../../../assets/topgolf/edit_default.svg"
								></ion-icon>
								<ion-icon
									(click)="delete()"
									[class.ion-hide]="!isEditable() || articleGroup?.isPromo"
									class="edit-btn"
									src="../../../assets/topgolf/delete_default.svg"
								></ion-icon>
							</div>
						</div>
					</div>
				</ion-col>
			</ion-row>
		}
	</ion-col>
</ion-row>
